import React, { Fragment } from 'react';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { UncontrolledTooltip } from 'reactstrap';
import { addParam } from '../../../../api/helper';
import { ROUTE_CLIENT_ORDER_VIEW } from '../../../../config/routes';
import { history, store } from '../../../../store/store';
import { ACL } from '../../../../config/constants';
import { hideNotification } from '../../../../store/actions/notification';

function ViewOrder(props) {
  if (! ACL.CLIENT.ORDERS.VIEW.hasAccess()) {
    return null;
  }

  return (
    <Fragment>
      <Link
        to="#"
        className="cursor-pointer px-2 mx-2 link-icon-color"
        id={`view-order-icon-` + props.order.id}
        onClick={e => {
          e.preventDefault();
          store.dispatch(hideNotification());
          history.push(
            addParam(ROUTE_CLIENT_ORDER_VIEW, { ':id': props.order.id }));
        }}
      >
        <FontAwesomeIcon
          size="lg"
          className="cursor-pointer"
          pointerEvents="none"
          icon={faEye}
        />
      </Link>
      <UncontrolledTooltip
        delay={0}
        target={`view-order-icon-${props.order.id}`}
        modifiers={
          {
            preventOverflow: {
              enabled: true,
              boundariesElement: 'body'
            }
          }
        }
      >
        <FormattedMessage id="messages.view_order" />
      </UncontrolledTooltip>
    </Fragment>
  )
}

export { ViewOrder };
